import React, { useEffect, useMemo, useState } from 'react';
import { apiCall } from '../../utils/apiService';
import { getApiDisplayBase } from '../../utils/apiDisplayBase';
import { buildSendContactApiExamples } from './messageApiExampleBuilders';
import MessageApiExamplesPanel from './MessageApiExamplesPanel';
import MessageHeaderLayer from './MessageHeaderLayer';

const ContactLayer = () => {
    const [alertMessage, setAlertMessage] = useState('');
    const [spinner, setSpinner] = useState(false);
    const [data, setData] = useState({
        client_id: null,
        token: null,
        name:null,
        phone:null,
        type: "contact"
    });

    // send single message code
    const handleSubmit = async (e) => {
        e.preventDefault();
        const { isValid, messageText } = validated();
        if (isValid) {
            setSpinner(true);
            try {
                // Create a FormData object
                const formData = new FormData();

                // Append each field from the media state to the FormData object
                for (let key in data) {
                    formData.append(key, data[key]);
                }
                const response = await apiCall({
                    url: 'send-message/send-contact',
                    method: 'POST',
                    body: formData,
                    withoutStringify: true
                });

                setAlertMessage({ message: response.msg, class: 'success' });
                if (response.success) {
                    cleanForm()
                }

            } catch (error) {
                setAlertMessage({ message: error.message, class: 'danger' });
                console.error('Login error:', error);
                hideAlert(2);
            }
        } else {
            setAlertMessage({ message: messageText, class: 'danger' });
            hideAlert(2);
        }
    };

    // validate form
    const validated = () => {
        if (data.client_id == '' || data.client_id == null) {
            return { isValid: false, messageText: 'Instance is required!' };
        } else if (data.token == '' || data.token == null) {
            return { isValid: false, messageText: 'Token is required!' };
        } else if (data.mobile == '' || data.mobile == null) {
            return { isValid: false, messageText: 'Phone is required!' };
        } else if (data.name == '' && data.name == null) {
            return { isValid: false, messageText: 'Contact name is required!' };
        } else if (data.phone == '' || data.phone == null) {
            return { isValid: false, messageText: 'Contact number is required!' };
        }
        return { isValid: true, messageText: '' }
    }

    // after submission form will be cleared
    const cleanForm = () => {
        // setData({
        //   content: { text: "" },
        //   fromTemplet: false,
        //   message: null,
        //   name: null,
        //   mobile: null,
        //   onlySave: false,
        //   saveAsTemplet: false,
        //   type: "text"
        // });
        setSpinner(false);
        hideAlert(2);
    }

    // hide alert after few seconds
    const hideAlert = (sec = 1) => {
        setTimeout(() => {
            setAlertMessage('');
            setSpinner(false);
        }, (sec * 1000));
    }


    useEffect(() => {
        document.title = "Send Contact"
    }, []);

    const apiBase = getApiDisplayBase();
    const codeExamples = useMemo(() => buildSendContactApiExamples(apiBase), [apiBase]);

    return (
        <>
            <div className='card'>
                <div className="card-body">
                    <MessageHeaderLayer getHeaderData={(id, apiKey) => setData({ ...data, client_id: id, token: apiKey })} />
                    <div className="row g-0">
                        <div className="col-md-6 mt-3 pe-md-3">
                            <form className='border rounded' onSubmit={handleSubmit}>
                                <div className='p-3 text-white' style={{ borderTopLeftRadius: '5px', borderTopRightRadius: '5px', background: '#26a69a' }}>
                                    Request test
                                </div>
                                <div className="row m-0 g-0 p-3">
                                    <div className="alert alert-success" style={{ fontSize: '12px' }}>
                                        Note: Use it wisely, not recommended to check bulk numbers
                                    </div>
                                    {
                                        alertMessage && (
                                            <div className={`alert alert-${alertMessage.class}`} style={{ fontSize: '12px' }}>
                                                {alertMessage.message}
                                            </div>
                                        )
                                    }
                                    <input type='number' className="form-control" placeholder='Phone: 923037900571' value={data.mobile} onChange={(e) => setData({ ...data, mobile: e.target.value })} />
                                    <span style={{ fontSize: '10px', color: 'gray' }}>Mobile number with country code without +</span>

                                    <input type="text" placeholder='Contact Name' className='form-control my-3' name="" id="" value={data.name} onChange={(e) => setData({
                                        ...data,
                                        name: e.target.value
                                    })} />
                                    <input type="text" placeholder='Contact Number' className='form-control mb-3' name="" id="" value={data.phone} onChange={(e) => setData({
                                        ...data,
                                        phone: e.target.value
                                    })} />
                                    <div className='d-flex justify-content-center mt-3'>
                                        <button type='submit' className='btn btn-success' style={{ background: '#26a69a' }}>Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-6 mt-3 ps-md-3">
                            <MessageApiExamplesPanel examples={codeExamples} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactLayer